export default ({ value = '', required }) =>
  value
    ? value.match(
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))*@[\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/,
      )
      ? ''
      : __('Please enter a valid email')
    : required
    ? __('Required field')
    : ''
